var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCryptocurrencyjobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 32,
    fill: "#A8B0D8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9932 54.9807L47.9996 61.5648L37.0068 54.9807V41.8948L37.0342 41.9116L47.9315 35.3851L58.8969 41.9524L58.9932 41.8948L70 35.3224V35.2991L50.5526 23.2281C49.7812 22.7493 48.899 22.4965 48 22.4965C47.101 22.4965 46.2189 22.7493 45.4474 23.2281L28.4195 33.799C27.6817 34.2567 27.071 34.9051 26.6469 35.6809C26.2228 36.4566 25.9999 37.3332 26 38.225V57.7741C25.9999 58.6659 26.2228 59.5425 26.6469 60.3182C27.071 61.094 27.6817 61.7424 28.4195 62.2001L45.4474 72.771C46.2189 73.2498 47.101 73.5026 48 73.5026C48.899 73.5026 49.7812 73.2498 50.5526 72.771L70 60.6985V48.4097L58.9932 54.9836V54.9807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0068 41.8953V41.9302L37.0363 41.9131L37.0068 41.8953Z",
    fill: "#6100C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9323 61.5638L36.9711 54.9987V41.9514L47.9323 48.5158V61.5638Z",
    fill: "#14E014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9323 48.5289L36.9711 41.9645L47.9323 35.3862L58.8935 41.9514L47.9323 48.5289Z",
    fill: "#00FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8934 55.0125L47.9323 61.5769V48.5296L58.8934 41.9645V55.0125Z",
    fill: "#0FCE0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 51,
    fill: "white",
    transform: "translate(26 22.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptocurrencyjobs);
export default __webpack_public_path__ + "static/media/cryptocurrencyjobs.97376231bb183160f5fcfc2635fc7d5e.svg";
export { ForwardRef as ReactComponent };